var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18Plus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,21.4v-8.7h-2v-2.2h4.8v10.9h-2.8ZM23.3,13.4c0,.9-.5,1.8-1.4,2.3,1.2.5,1.9,1.5,1.9,2.8,0,2-1.7,3.2-4.5,3.2s-4.5-1.2-4.5-3.2.8-2.3,2.1-2.8c-.9-.5-1.5-1.4-1.5-2.3,0-1.7,1.5-2.8,3.9-2.8,2.4,0,3.9,1.1,3.9,2.9ZM17.6,18.1c0,.9.7,1.4,1.9,1.4s1.9-.5,1.9-1.4-.7-1.4-1.9-1.4-1.9.5-1.9,1.4ZM17.8,13.5c0,.8.6,1.2,1.6,1.2s1.6-.4,1.6-1.2-.6-1.3-1.6-1.3-1.6.5-1.6,1.3ZM28.5,11.8c.5,1.4.7,2.8.7,4.2,0,7.3-5.9,13.2-13.2,13.2S2.8,23.3,2.8,16,8.7,2.8,16,2.8s2.9.2,4.2.7V.6C18.9.2,17.4,0,16,0,7.2,0,0,7.2,0,16s7.2,16,16,16,16-7.2,16-16-.2-2.9-.6-4.2c0,0-2.9,0-2.9,0ZM27.7,4.3V1.2h-2.2v3.1h-3v2.2h3v3.1h2.2v-3.1h3.1v-2.2h-3.1Z",
    fill: "#aaa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18Plus);
export default __webpack_public_path__ + "static/media/18-plus.26a8f98da5df954cc383cdf5b02872df.svg";
export { ForwardRef as ReactComponent };